import { ListType } from "../../../../shared/Enums/Enums";
import { MenuComponent } from "../../../../shared/screen-components/CommonMenuComponent/CommonMenuComponent";
import SpreadImportWrapper from "../../../../shared/screen-components/ExcelViewComponent/SpreadImportWrapperComponent";
import CoaExcelStyle from "./CoaExcelView.module.css";

const CoaExcelView = () => {
  return (
    <div className={CoaExcelStyle.excelView}>
      <MenuComponent menuType={ListType.Coa} />
      <SpreadImportWrapper />
    </div>
  );
};

export default CoaExcelView;
